<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-row>
                <b-col md="6">
                    <div class="font-weight-bold">Kloter Pengiriman</div>
                    {{ $helper.parseDate(item.delivery_date) }} - Cabang {{ item.branch }}
                </b-col>
                <b-col md="6">
                    <div class="font-weight-bold">Status Barang</div>
                    <b-badge :variant="parseStatusVariant(item.status)">
                        {{ parseStatusName(item.status) }}
                    </b-badge>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="6">
                    <div class="font-weight-bold">Jenis Barang</div>
                    {{ item.kind }}
                    <div class="font-weight-bold mt-3">Merk Barang</div>
                    {{ item.brand }}
                    <div class="font-weight-bold mt-3">Tipe Barang</div>
                    {{ item.type }}
                    <div class="font-weight-bold mt-3">Spek dari PGI</div>
                    {{ specName(item.pgi_spec_id) }}
                    <div class="font-weight-bold mt-3">Tahun / Generasi Barang</div>
                    {{ item.year || "-" }}
                </b-col>
                <b-col md="6">
                    <div class="font-weight-bold">No. Faktur PGI</div>
                    {{ item.no_faktur }}
                    <div class="font-weight-bold mt-3">IMEI / SN</div>
                    {{ item.imei_sn }}
                    <div class="font-weight-bold mt-3">Password</div>
                    {{ item.password || "-" }}
                    <div class="font-weight-bold mt-3">Grade / Kelengkapan dari PGI</div>
                    {{ item.grade_pgi || "-" }} / {{ item.is_batangan_pgi == 1 ? "Batangan" : "Lengkap" }}
                </b-col>
            </b-row>
            <div v-if="item.status == 1" class="mt-3">
                <b-button variant="warning" :disabled="isGradeOnly"
                    :title="isGradeOnly ? 'Hanya dapat melakukan input data Grade' : ''" @click="prepareChange">
                    <i class="fa fa-pencil mr-2" />Ubah Barang
                </b-button>
                <b-button variant="danger" class="ml-2" :disabled="isGradeOnly"
                    :title="isGradeOnly ? 'Hanya dapat melakukan input data Grade' : ''"
                    @click="$bvModal.show('m-request-lost')">
                    <i class="fa fa-times mr-2" />Nyatakan Hilang
                </b-button>
            </div>
            <hr />
            <div v-if="item.status == 1"><!-- PENDING -->
                <h5>Input Data Barang</h5>
                <small class="form-text text-muted" v-if="isGradeOnly">Status barang dalam kondisi Reset Grade dan data
                    yang
                    dapat di-input terbatas.</small>
                <b-row class="mt-3">
                    <b-col md="3">
                        <b-form-group label="Grade Barang">
                            <b-form-select v-model="input.grade" :options="optGrade" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" v-if="!isGradeOnly">
                        <b-form-group label="Kelengkapan Barang">
                            <b-form-select v-model="input.isBatangan" :options="optBatangan" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" v-if="!isGradeOnly">
                        <b-form-group label="Spek Barang">
                            <b-form-select v-model="input.spec" :options="optSpec" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" v-if="!isGradeOnly">
                        <b-form-group label="Warna Barang">
                            <b-form-select v-model="input.color" :options="optColor" />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="input.grade == 'X'">
                    <b-col md="12">
                        <b-form-group :label="'Penyesuaian Harga Grade ' + input.grade"
                            description="Gunakan tanda negatif didepan untuk pengurangan harga (Bila positif, maka dianggap penambahan harga)">
                            <b-input-group prepend="Rp.">
                                <b-input v-model="input.adjGrade" @input="sanitizeAdjGrade" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="!isGradeOnly">
                    <!-- <b-col md="6" v-if="optAccessories.length != 0">
                        <b-form-group label="Accessories yang Tidak Ada">
                            <multiselect v-model="input.missingAcc" :multiple="true" label="name" track-by="id"
                                :internal-search="true" deselect-label="" select-label="" :options="optAccessories"
                                :close-on-select="false" @input="test" />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" v-if="optAccessories.length != 0">
                        <b-form-group label="Accessories yang Tidak Ori">
                            <multiselect v-model="input.nonOriAcc" :multiple="true" label="name" track-by="id"
                                :internal-search="true" deselect-label="" select-label="" :options="optAccessories"
                                :close-on-select="false" />
                        </b-form-group>
                    </b-col> -->
                    <b-col md="12" class="mb-4">
                        <b-table bordered hover show-empty no-local-sorting :items="adjustments" :fields="fieldsAdjust"
                            responsive class="mt-4 mb-1">
                            <template v-slot:empty>
                                Tidak ada adjustment.
                            </template>
                            <template v-slot:cell(category)="row">
                                <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                                <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                                <!-- <b-form-select v-model="row.item.category" :options="optCategory" @change="onChangeRowCategory(row.index)"
                                :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/> -->
                                <b-form-select v-model="row.item.category" :options="optCategory"
                                    @change="onChangeRowCategory(row.index)" />
                            </template>
                            <template v-slot:cell(name)="row">
                                <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                                <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                                <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments" @change="changeAdjustment" :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)"/>
                                <small class="text-muted" v-if="row.item.adjustmentSelect === null || row.item.adjustmentSelect.id == null">{{row.item.name_placeholder}}</small> -->
                                <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments"
                                    :disabled="!row.item.category || row.item.optAdjustments.length <= 0" />
                            </template>
                            <template v-slot:cell(adjustment)="row">
                                <b-input-group prepend="Rp.">
                                    <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                    <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" disabled></b-form-input> -->
                                    <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || activeItem.status == '3'" ></b-form-input> -->
                                    <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)"
                                        :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || !row.item.adjustmentSelect"></b-form-input>
                                </b-input-group>
                            </template>
                            <template v-slot:cell(adjustmentPercent)="row">
                                <b-input-group append="%">
                                    <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                                    <!-- <b-form-input v-model="row.item.adjustmentPercentage" disabled></b-form-input> -->
                                    <!-- <b-form-input v-model="row.item.adjustmentPercentage" @input="changeAdjustment" :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || activeItem.status == '3'"></b-form-input> -->
                                    <b-form-input v-model="row.item.adjustmentPercentage"
                                        :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || !row.item.adjustmentSelect"></b-form-input>
                                </b-input-group>
                            </template>
                            <template v-slot:cell(action)="row">
                                <div class="d-flex">
                                    <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Tambah"
                                        @click="addRow">
                                        <i class="fa fa-fw fa-plus" />
                                    </b-button>
                                    <b-button variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top
                                        title="Hapus" @click="deleteRow(row.index)">
                                        <i class="fa fa-fw fa-times" />
                                    </b-button>
                                </div>
                            </template>
                        </b-table>
                        <span class="text-muted small mt-1">Biarkan tabel kosong apabila tidak ada adjustment
                            harga</span>
                    </b-col>
                    <!-- <b-col md="4"> -->
                    <!-- <b-form-group label="Catatan Barang (opsional)">
                            <b-input v-model="input.note" maxlength="200" />
                        </b-form-group> -->
                    <!-- <b-form-group label="Kategori Kerusakan">
                            <multiselect v-model="input.category"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :options="optCategory"
                                 @input="onChangeCategory"
                            >
                            </multiselect>
                        </b-form-group>
                    </b-col>
                    <b-col md="8"> -->
                    <!-- <b-form-group label="Catatan Barang (opsional)">
                            <b-input v-model="input.note" maxlength="200" />
                        </b-form-group> -->
                    <!-- <b-form-group label="Adjustment Kerusakan">
                            <multiselect v-model="input.adjustments"
                                label="name"
                                track-by="id"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                :close-on-select="false"
                                :options="optAdjustments"
                                :disabled="$helper.isBlank(input.category) || optAdjustments.length <= 0"
                                multiple
                            >
                                diubah sementara supaya adjustment harga bisa diinput manual dulu
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc">
                                        <span class="option__title">{{ props.option.label }}</span>
                                        <span class="option__small text-muted"> ({{ props.option.category }})</span>
                                    </div>
                                </template>
                            </multiselect>
                        </b-form-group>
                    </b-col> -->
                    <!-- <b-col md="12">
                        <b-form-group label="Upload Foto Fisik (opsional, maks. 10 gambar)">
                            <b-form-file multiple v-model="input.photos" accept="image/jpeg, image/png" />
                            <span class="text-muted small">Jumlah foto fisik : {{ item.photo_count }}</span>
                        </b-form-group>
                    </b-col> -->
                    <!-- <b-col md="12">
                        <b-form-group label="Penyesuaian Harga Lainnya" description="Biarkan 0 apabila tidak ada. Gunakan tanda negatif didepan untuk pengurangan harga (Bila positif, maka dianggap penambahan harga)">
                            <b-input-group prepend="Rp.">
                                <b-input v-model="input.adjOther" @input="sanitizeAdjOther" />
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Catatan Penyesuaian Harga Lainnya" description="Wajib diisi apabila penyesuaian harga lainnya tidak sama dengan nol">
                            <b-input v-model="input.adjOtherNote" maxlength="200" />
                        </b-form-group>
                    </b-col> -->
                </b-row>
                <b-row>
                    <b-col md="12" class="text-right">
                        <b-button variant="success" :disabled="isSubmitting" @click="promptSubmitGrade"
                            v-if="isGradeOnly">
                            {{ isSubmitting ? "Menyimpan..." : "Approve Perubahan Grade" }}
                        </b-button>
                        <b-button variant="success" :disabled="isSubmitting" @click="promptSubmit" v-if="!isGradeOnly">
                            {{ isSubmitting ? "Menyimpan..." : "Approve Barang" }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
            <div v-else-if="item.status == 5"><!-- HILANG -->
                <div>
                    Dinyatakan hilang oleh <span class="font-weight-bold">{{ item.approved_by }}</span> pada {{
            $helper.parseDate(item.approved_at) }}, {{ $helper.parseHourMinute(item.approved_at) }} WIB
                </div>
            </div>
            <div v-else><!-- APPROVED, LAINNYA -->
                <h5 class="mb-0">Input Data Barang</h5>
                <div class="text-muted">
                    Approval dilakukan oleh <span class="font-weight-bold">{{ item.approved_by }}</span> pada {{
            $helper.parseDate(item.approved_at) }}, {{ $helper.parseHourMinute(item.approved_at) }} WIB
                </div>
                <b-row class="mt-3">
                    <b-col md="6">
                        <div class="font-weight-bold">Grade</div>
                        {{ item.grade }}
                        <div class="font-weight-bold mt-3">Kelengkapan</div>
                        {{ item.is_batangan == true ? "Batangan" : "Lengkap" }}
                        <div class="font-weight-bold mt-3">Spek</div>
                        {{ item.spec }}
                        <div class="font-weight-bold mt-3">Lokasi Penyimpanan</div>
                        {{ item.warehouse || "-" }}
                    </b-col>
                    <b-col md="6">
                        <div class="font-weight-bold">Aksesoris yang Tidak Ada</div>
                        {{ item.missing_accessories || "-" }}
                        <div class="font-weight-bold mt-3">Aksesoris yang Tidak Ori</div>
                        {{ item.not_ori_accessories || "-" }}
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal id="m-change" title="Pengubahan Barang" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isFetching">Mengambil data, mohon menunggu...</div>
            <div v-else>
                <b-form-group label="Jenis Barang">
                    <multiselect v-model="change.kind" label="name" track-by="id" :internal-search="true"
                        deselect-label="" select-label="" :allow-empty="false" :options="optChangeKind" />
                </b-form-group>
                <b-form-group label="Merk Barang">
                    <multiselect v-model="change.brand" label="name" track-by="id" :internal-search="true"
                        deselect-label="" select-label="" :allow-empty="false" :options="optChangeBrand" />
                </b-form-group>
                <b-form-group label="Tipe Barang">
                    <multiselect v-model="change.type" label="name" track-by="id" :internal-search="true"
                        deselect-label="" select-label="" :allow-empty="false" :options="optChangeType"
                        placeholder="Pilih tipe barang..." />
                </b-form-group>
                <b-form-group v-if="change.type != null && change.type.has_year == true"
                    label="Tahun / Generasi Barang">
                    <b-form-select v-model="change.year" :options="optChangeYear">
                        <template #first>
                            <b-select-option value=0 disabled>Pilih tahun / generasi...</b-select-option>
                        </template>
                    </b-form-select>
                </b-form-group>
                <b-form-group label="IMEI / SN">
                    <b-input v-model="change.imeiSn" maxlength="100" />
                </b-form-group>
                <b-form-group label="Password">
                    <b-input v-model="change.password" maxlength="100" />
                </b-form-group>
                <div class="text-right mt-4">
                    <b-button variant="primary" :disabled="isSubmitting" @click="promptChange">
                        {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                    </b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-request-lost" title="Nyatakan Barang Hilang" centered hide-footer no-close-on-backdrop
            no-close-on-esc>
            <b-form-group label="Keterangan Hilang">
                <b-input v-model="noteLost" maxlength="200" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="promptItemLost">
                    {{ isSubmitting ? "Menyimpan..." : "Nyatakan Hilang" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-barcode" title="Cetak Barcode" centered no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Kerusakan' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="finishApproval">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>

import lodash from 'lodash'

export default {
    name: 'barang-masuk-detail-barang',
    props: {
        inventoryId: { type: Number, required: true }
    },
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,
            firstLoad: false,

            item: {},
            input: {
                grade: "A",
                adjGrade: "",
                spec: 1,
                warehouse: 0,
                isBatangan: false,
                missingAcc: [],
                nonOriAcc: [],
                // note: "",
                photos: [],
                adjOther: "0",
                adjOtherNote: "",
                adjustments: [],
                category: "",
                color: -1
            },

            change: {
                kind: {},
                brand: {},
                type: {},
                year: {},
                imeiSn: "",
                password: ""
            },

            noteLost: "",

            optGrade: ["S", "A", "B", "C", "X"],
            optSpec: [],
            optWarehouse: [],
            optBatangan: [
                { value: false, text: "Lengkap" },
                { value: true, text: "Batangan" }
            ],
            optAccessories: [],

            optChangeKind: [],
            optChangeBrand: [],
            optChangeType: [],
            optChangeYear: [],

            optColor: [],

            barcodeLink: "",
            barcodeLinkDamage: "",

            barcodeType: 'barcode',
            barcodeToggleCooldown: false,

            adjustments: [],
            optAdjustments: [],
            optCategory: [],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "adjustmentPercent", label: "Potongan / Tambahan Harga (Persen)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

        }
    },
    watch: {

        "change.kind": function (newVal, oldVal) {

            let isSame = newVal != null && oldVal != null && newVal.id == oldVal.id
            if (this.firstLoad || newVal == null || isSame) {
                return
            }

            this.change.brand = null
            this.change.type = null
            this.change.year = 0
            this.optChangeBrand = []
            this.optChangeType = []
            this.optChangeYear = []

            this.$axios.get("master/brands/" + newVal.id).then(res => {
                let data = res.data.data
                this.optChangeBrand = data
            })

        },

        "change.brand": function (newVal, oldVal) {

            let isSame = newVal != null && oldVal != null && newVal.id == oldVal.id
            if (this.firstLoad || newVal == null || isSame) {
                return
            }

            this.change.type = null
            this.change.year = 0
            this.optChangeType = []
            this.optChangeYear = []

            this.$axios.get("master/types/" + newVal.id).then(res => {
                let data = res.data.data
                this.optChangeType = data
            })

        },

        "change.type": function (newVal, oldVal) {

            let isSame = newVal != null && oldVal != null && newVal.id == oldVal.id
            if (this.firstLoad || newVal == null || isSame) {
                return
            }

            this.change.year = 0;
            this.optChangeYear = []

            if (newVal.has_year == true) {

                this.$axios.get("master/years/" + newVal.id).then(res => {
                    let data = res.data.data
                    this.optChangeYear = data.map(it => it.year)
                })

            }

        }

    },
    methods: {

        init() {

            this.initStatus = 0
            this.optSpec = [];
            this.optWarehouse = [];
            this.optAccessories = [];
            this.optColor = [{ value: -1, text: "Pilih Warna" }];

            this.$axios.get("delivery/inventory/" + this.inventoryId).then(res => {
                this.item = res.data.data

                this.item.available_specs.forEach(it => {
                    this.optSpec.push({ value: it.id, text: it.name })
                })

                this.input.spec = this.item.pgi_spec_id ? this.item.pgi_spec_id : this.optSpec[0].value

                this.item.available_warehouses.forEach(it => {
                    this.optWarehouse.push({ value: it.id, text: it.name })
                })

                this.item.available_accessories.forEach(it => {
                    this.optAccessories.push({ id: it.id, name: it.name })
                })

                this.input.isBatangan = this.item.is_batangan_pgi == true

                this.input.color = this.item.item_color_id

                if (!this.item.has_grade_s) {
                    this.optGrade.shift()
                }

                // let getCategories = this.$axios.get("category/selection?item_kind_id=" + this.item.kind_id).then(res => {
                //     this.optCategory = res.data.data.map(item => {
                //         return {
                //             value: item.id,
                //             text: item.name
                //         }
                //     })
                // })

                let getColors = this.$axios.get("master/color/selection").then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        this.optColor.push({
                            value: res.data.data[i].id,
                            text: res.data.data[i].name
                        })
                    }
                })


                let getAdjustments = this.$axios.get("category/selection?item_kind_id=" + this.item.kind_id).then(res => {
                    this.optCategory = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    let param = "?id=" + this.item.id
                    this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].optAdjustments.length > 0) {
                                for (let j = 0; j < res.data.data[i].optAdjustments.length; j++) {
                                    if (res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id) {
                                        this.adjustments.push({
                                            name_placeholder: res.data.data[i].adjustments_name,
                                            name: res.data.data[i].adjustments_name,
                                            category: res.data.data[i].category_id,
                                            adjustmentSelect: {
                                                id: res.data.data[i].optAdjustments[j].id,
                                                name: res.data.data[i].optAdjustments[j].name,
                                                adjustment: res.data.data[i].optAdjustments[j].adjustment,
                                                adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                                            },
                                            adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                            adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                            optAdjustments: res.data.data[i].optAdjustments.map(item => {
                                                return {
                                                    value: {
                                                        id: item.id,
                                                        name: item.name,
                                                        adjustment: item.adjustment,
                                                        adjustment_percentage: item.adjustment_percentage,
                                                    },
                                                    text: item.name
                                                }
                                            })
                                        })
                                        break
                                    }
                                }
                            }
                            else {
                                this.adjustments.push({
                                    name_placeholder: res.data.data[i].adjustments_name,
                                    name: res.data.data[i].adjustments_name,
                                    category: res.data.data[i].category_id,
                                    adjustmentSelect: {
                                        id: res.data.data[i].adjustments_id,
                                        name: res.data.data[i].adjustments_name,
                                        adjustment: res.data.data[i].adjustment,
                                        adjustment_percentage: res.data.data[i].adjustment_percentage
                                    },
                                    adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                    adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                    optAdjustments: []
                                })
                            }
                            // diubah sementara supaya adjustment harga bisa diinput manual dulu
                            // this.adjustments.push({
                            //     name: res.data.data[i].adjustments_name,
                            //     adjustmentSelect: {
                            //         id: res.data.data[i].adjustments_id,
                            //         name: res.data.data[i].adjustments_name,
                            //         adjustment: res.data.data[i].adjustment,
                            //         adjustment_percentage: res.data.data[i].adjustment_percentage
                            //     },
                            //     adjustment: res.data.data[i].adjustment,
                            //     adjustmentPercentage: res.data.data[i].adjustment_percentage
                            // })
                        }
                        for (var i = 0; i < this.adjustments.length; i++) {
                            let adj = this.adjustments[i]
                            this.sanitize(adj)
                        }
                        if (this.adjustments.length <= 0) this.addRow()
                    })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => this.isSubmitting = false)
                })

                Promise.all([getAdjustments, getColors]).then(res => {
                    this.initStatus = 1
                }).catch(error => {
                    this.$helper.parseError(this, error)
                    this.initStatus = -1
                })
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.initStatus = -1
                })

        },

        promptItemLost() {

            if (this.noteLost == "") {
                return this.$helper.toastError(this, "Mohon mengisi keterangan!")
            }

            let isConfirmed = confirm("Nyatakan barang ini hilang?")
            if (!isConfirmed) return

            this.isSubmitting = true
            let payload = {
                id: this.inventoryId,
                note: this.noteLost
            }

            this.$axios.post("delivery/lost", payload).then(res => {
                this.$emit("lost")
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        getBarcodeLink() {
            if (this.barcodeType == 'barcode') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
            }
            else {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkDamage}`
            }
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'damage'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        promptSubmit() {

            let confirmable = true
            let isAdjustmentEmpty = false

            // if (this.input.photos.length + this.item.photo_count > 10) {
            //     confirmable = false
            //     return this.$helper.toastError(this, "Upload foto maksimum 10 foto!")
            // }

            let gradesWithManualAdjustment = ["X"]
            if (gradesWithManualAdjustment.includes(this.input.grade) && this.$helper.isBlank(this.input.adjGrade)) {
                confirmable = false
                return this.$helper.toastError(this, "Mohon mengisi penyesuaian harga grade untuk Grade X!")
            }

            if (this.$helper.isBlank(this.input.adjOther)) {
                confirmable = false
                return this.$helper.toastError(this, "Penyesuaian harga lainnya tidak boleh kosong. Isi dengan angka nol apabila tidak ada penyesuaian lainnya!")
            }

            if (this.input.adjOther != "0" && this.$helper.isBlank(this.input.adjOtherNote)) {
                confirmable = false
                return this.$helper.toastError(this, "Mohon mengisi catatan penyesuaian harga lainnya!")
            }

            if (this.input.color == -1 && this.optColor.length > 1) {
                confirmable = false
                return this.$helper.toastError(this, "Mohon mengisi pilihan warna barang!")
            }

            // if (this.input.grade != "A" && this.input.grade != "S") {
            //     if (this.input.photos.length < 6) {
            //         confirmable = false
            //         return this.$helper.toastError(this, "Mohon upload foto min 6!")
            //     }
            // }

            if (this.input.color == -1) {
                this.input.color = null
            }

            if (this.adjustments.length == 1) {
                if (this.$helper.isBlank(this.adjustments[0].category) && this.$helper.isBlank(this.adjustments[0].adjustmentSelect) && (this.$helper.isBlank(this.adjustments[0].adjustment) && this.$helper.isBlank(this.adjustments[0].adjustmentPercentage)) && this.$helper.isBlank(this.adjustments[0].adjustmentSelect.id)) {
                    isAdjustmentEmpty = true
                }
                else if (this.$helper.isBlank(this.adjustments[0].category) || this.$helper.isBlank(this.adjustments[0].adjustmentSelect) || (this.$helper.isBlank(this.adjustments[0].adjustment) && this.$helper.isBlank(this.adjustments[0].adjustmentPercentage)) || this.$helper.isBlank(this.adjustments[0].adjustmentSelect.id)) {
                    confirmable = false
                    return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                }
            }
            else {
                for (var i = 0; i < this.adjustments.length; i++) {
                    let adj = this.adjustments[i]
                    if (this.$helper.isBlank(adj.adjustmentSelect) || (this.$helper.isBlank(adj.adjustment) && this.$helper.isBlank(adj.adjustmentPercentage)) || this.$helper.isBlank(adj.adjustmentSelect.id)) {
                        confirmable = false
                        return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                    }
                }
            }

            if (confirmable) {
                let confirmed = confirm("Lakukan approval dengan data input ini?")
                if (confirmed) {

                    let payload = new FormData()
                    // this.input.photos.forEach(it => {
                    //     payload.append("photos[]", it)
                    // })

                    let jsonData = {
                        id: this.inventoryId,
                        grade: this.input.grade,
                        spec: this.input.spec,
                        colorId: this.input.color,
                        isBatangan: this.input.isBatangan,
                        missingAcc: this.input.missingAcc,
                        nonOriAcc: this.input.nonOriAcc,
                        // note: this.input.note,
                        adjGrade: this.$helper.toNumber(this.input.adjGrade),
                        adjOther: this.$helper.toNumber(this.input.adjOther),
                        adjOtherNote: this.input.adjOtherNote
                        // adjInvoice: this.input.adjustments.map(item => {
                        //     return {
                        //         adjustment_id: item.id,
                        //         name: item.name,
                        //         adjustment: item.adjustment,
                        //         adjustmentPercentage: item.adjustment_percentage
                        //     }
                        // })
                    }

                    if (isAdjustmentEmpty) {
                        jsonData["adjInvoice"] = []
                    }
                    else {
                        jsonData["adjInvoice"] = this.adjustments.map(it => {
                            if (this.$helper.isBlank(it.adjustmentPercentage)) {
                                return {
                                    name: it.adjustmentSelect.name,
                                    adjustment: this.$helper.toNumber(it.adjustment),
                                    adjustmentPercentage: null,
                                    adjustment_id: it.adjustmentSelect.id
                                }
                            }
                            else {
                                return {
                                    name: it.adjustmentSelect.name,
                                    adjustment: null,
                                    adjustmentPercentage: Number(parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2),
                                    adjustment_id: it.adjustmentSelect.id
                                }
                            }
                        })
                    }

                    // payload.append("data", JSON.stringify(jsonData))

                    this.isSubmitting = true
                    this.$axios.post("delivery/approve", jsonData).then(res => {
                        this.barcodeLink = res.data.data.link
                        this.barcodeLinkDamage = res.data.data.linkDamage
                        this.$bvModal.show('m-barcode')
                    })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => this.isSubmitting = false)

                }
            }




        },

        promptSubmitGrade() {

            let gradesWithManualAdjustment = ["X"]
            if (gradesWithManualAdjustment.includes(this.input.grade) && this.$helper.isBlank(this.input.adjGrade)) {
                return this.$helper.toastError(this, "Mohon mengisi penyesuaian harga grade untuk Grade X!")
            }

            let confirmed = confirm("Lakukan approval dengan data input ini?")
            if (confirmed) {

                let payload = new FormData()

                let jsonData = {
                    id: this.inventoryId,
                    grade: this.input.grade,
                    adjGrade: this.$helper.toNumber(this.input.adjGrade)
                }

                payload.append("data", JSON.stringify(jsonData))

                this.isSubmitting = true
                this.$axios.post("delivery/approve-grade", payload).then(res => {
                    this.barcodeLink = res.data.data.link
                    this.barcodeLinkDamage = res.data.data.linkDamage
                    this.$bvModal.show('m-barcode')
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            }

        },

        finishApproval() {
            this.$bvModal.hide('m-barcode')
            this.$emit("approved")
        },

        prepareChange() {

            this.$bvModal.show("m-change")

            this.isFetching = true
            this.$axios.get("delivery/request-change/" + this.inventoryId).then(res => {
                let data = res.data.data

                this.firstLoad = true
                this.change.kind = {
                    id: data.id_kind,
                    name: data.name_kind
                }
                this.change.type = {
                    id: data.id,
                    name: data.name,
                    has_year: data.year != null
                }

                this.change.brand = {
                    id: data.id_brand,
                    name: data.name_brand
                }

                this.change.year = data.year
                this.change.imeiSn = data.imei_sn
                this.change.password = data.password

                this.optChangeKind = data.opt_kind
                this.optChangeBrand = data.opt_brand
                this.optChangeType = data.opt_type
                this.optChangeYear = data.opt_year.map(it => it.year)
                this.$nextTick(() => this.firstLoad = false)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isFetching = false)

        },

        promptChange() {
            if (this.change.kind == null || this.change.brand == null || this.change.type == null) {
                return this.$helper.toastError(this, "Mohon memilih jenis, merk, dan tipe barang!")
            }
            if (this.change.type.has_year == true && this.change.year == 0) {
                return this.$helper.toastError(this, "Mohon memilih tahun / generasi!")
            }

            let isConfirmed = confirm("Lakukan perubahan barang sesuai dengan data ini?")
            if (isConfirmed) {

                let payload = {
                    id: this.inventoryId,
                    kindId: this.change.kind.id,
                    brandId: this.change.brand.id,
                    typeId: this.change.type.id,
                    year: this.change.type.has_year ? this.change.year : null,
                    imeiSn: this.change.imeiSn,
                    password: this.change.password
                }

                this.isSubmitting = true
                this.$axios.post("delivery/change", payload).then(res => {

                    let data = res.data.data
                    this.item.kind = data.kind
                    this.item.type = data.type
                    this.item.year = data.year
                    this.item.brand = data.brand
                    this.item.password = data.password
                    this.item.imei_sn = data.imeiSn

                    this.$helper.toastSuccess(this, "Data barang berhasil diubah!")
                    this.$bvModal.hide("m-change")
                    this.$emit("edited", data.type, data.year) // not used

                    this.init()

                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            }

        },

        parseStatusVariant(status) {

            switch (status) {
                case 1: return "warning"
                case 2: return "success"
                case 5: return "danger"
                default: return "light"
            }

        },

        parseStatusName(status) {

            switch (status) {
                case 1: return "PENDING"
                case 2: return "APPROVED"
                case 5: return "HILANG"
                default: return "LAINNYA"
            }

        },

        sanitizeAdjGrade() {
            let cleaned = String(this.input.adjGrade).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.adjGrade = res
        },

        sanitizeAdjOther() {
            let cleaned = String(this.input.adjOther).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.input.adjOther = res
        },

        // onChangeCategory(){
        //     this.optAdjustments = []
        //     if(!this.$helper.isBlank(this.input.category)){
        //         let param = "?item_kind_id=" + this.item.kind_id
        //         param += "&category_id=" + this.input.category.id
        //         this.isSubmitting = true
        //         this.$axios.get("adjustment/selection-category" + param).then(res => {
        //             this.optAdjustments = res.data.data.map(item => {
        //                 return {
        //                     id: item.id,
        //                     name: this.input.category.name + ' - ' + item.name,
        //                     label: item.name,
        //                     category: this.input.category.name
        //                 }
        //             })
        //             this.isSubmitting = false
        //         })
        //     }
        // },


        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
        },
        addRow() {
            this.adjustments.push({ name: "", category: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "", optAdjustments: [] })
        },
        deleteRow(index) {
            this.adjustments.splice(index, 1)
            if (this.adjustments.length <= 0) {
                this.addRow()
            }
        },
        onChangeRowCategory(index) {
            this.adjustments[index].name = ""
            this.adjustments[index].adjustmentSelect = null
            this.adjustments[index].optAdjustments = []
            if (!this.$helper.isBlank(this.adjustments[index].category)) {
                let param = "?item_kind_id=" + this.item.kind_id
                param += "&category_id=" + this.adjustments[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.adjustments[index].optAdjustments = res.data.data.map(item => {
                        return {
                            value: {
                                id: item.id,
                                name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentage: item.adjustment_percentage,
                            },
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        prepareAddAdjustment() {
            console.log(this.activeItem.fixing_adjustment)
            this.addAdj.optKind = [
                { value: this.activeItem.kind_id, text: this.activeItem.kind }
            ]
            this.addAdj.kind = this.activeItem.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            if (this.activeItem.fixing_adjustment) {
                this.addAdj.adjustment = "0"
                this.addAdj.adjustmentPercentage = ""
            } else {
                this.addAdj.adjustment = ""
                this.addAdj.adjustmentPercentage = ""
            }
            this.$bvModal.show("m-add-adjustment")
        },

        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(this, "Data Keterangan Adjustment Kerusakan tidak boleh kosong !")
                return
            }

            if (this.$helper.isBlank(this.addAdj.adjustment) && this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                if (!this.activeItem.fixing_adjustment) {
                    this.$helper.toastError(this, "Salah satu dari data Adjustment Nominal atau Persentase tidak boleh kosong !")
                    return
                }
            }

            let payload = new FormData()

            payload.append("inventory_id", this.activeItem.id)
            payload.append("adjustment_id", this.addAdj.name)
            if (this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                payload.append("adjustment", this.$helper.toNumber(this.addAdj.adjustment))
            }
            else {
                payload.append("adjustment", parseInt(this.activeItem.final_price * parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100))
                payload.append("adjustment_percentage", Number(parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2))
            }

            this.isSubmitting = true
            this.$axios.post("inventory/add-invoice-adjustments", payload).then(res => {

                let param = "?id=" + this.activeItem.id
                this.$axios.get("inventory/get-latest-invoice-adjustment" + param).then(res => {
                    //                    this.invoiceAdjustments = []
                    for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].optAdjustments.length > 0) {
                            for (let j = 0; j < res.data.data[i].optAdjustments.length; j++) {
                                if (res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id) {
                                    this.invoiceAdjustments.push({
                                        name: res.data.data[i].adjustments_name,
                                        category: res.data.data[i].category_id,
                                        adjustmentSelect: {
                                            id: res.data.data[i].optAdjustments[j].id,
                                            name: res.data.data[i].optAdjustments[j].name,
                                            adjustment: res.data.data[i].optAdjustments[j].adjustment,
                                            adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                                        },
                                        adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                        adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                        optAdjustments: res.data.data[i].optAdjustments.map(item => {
                                            return {
                                                value: {
                                                    id: item.id,
                                                    name: item.name,
                                                    adjustment: item.adjustment,
                                                    adjustment_percentage: item.adjustment_percentage,
                                                },
                                                text: item.name
                                            }
                                        })
                                    })
                                    break
                                }
                            }
                        }
                        else {
                            this.invoiceAdjustments.push({
                                name: res.data.data[i].adjustments_name,
                                category: res.data.data[i].category_id,
                                adjustmentSelect: {
                                    id: res.data.data[i].adjustments_id,
                                    name: res.data.data[i].adjustments_name,
                                    adjustment: res.data.data[i].adjustment,
                                    adjustment_percentage: res.data.data[i].adjustment_percentage
                                },
                                adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                optAdjustments: []
                            })
                        }
                        // diubah sementara supaya adjustment harga bisa diinput manual dulu
                        // this.invoiceAdjustments.push({
                        //     name: res.data.data[i].adjustments_name,
                        //     adjustmentSelect: {
                        //         id: res.data.data[i].adjustments_id,
                        //         name: res.data.data[i].adjustments_name,
                        //         adjustment: res.data.data[i].adjustment,
                        //         adjustment_percentage: res.data.data[i].adjustment_percentage
                        //     },
                        //     adjustment: res.data.data[i].adjustment,
                        //     adjustmentPercentage: res.data.data[i].adjustment_percentage
                        // })
                    }

                    for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                        let adj = this.invoiceAdjustments[i]

                        this.sanitize(adj)

                    }

                    this.$bvModal.hide("m-add-adjustment")
                    this.isChangeAdjustment = true
                })
                    // this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                    //     this.invoiceAdjustments = []
                    //     for(let i = 0; i < res.data.data.length; i++){
                    //         for(let j = 0; j < res.data.data[i].optAdjustments.length; j++){
                    //             if(res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id){
                    //                 this.invoiceAdjustments.push({
                    //                     name: res.data.data[i].adjustments_name,
                    //                     category: res.data.data[i].category_id,
                    //                     adjustmentSelect: {
                    //                         id: res.data.data[i].optAdjustments[j].id,
                    //                         name: res.data.data[i].optAdjustments[j].name,
                    //                         adjustment: res.data.data[i].optAdjustments[j].adjustment,
                    //                         adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                    //                     },
                    //                     adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                    //                     adjustmentPercentage: res.data.data[i].adjustment_percentage,
                    //                     optAdjustments: res.data.data[i].optAdjustments.map(item => {
                    //                         return {
                    //                             value: {
                    //                                 id: item.id,
                    //                                 name: item.name,
                    //                                 adjustment: item.adjustment,
                    //                                 adjustment_percentage: item.adjustment_percentage,
                    //                             },
                    //                             text: item.name
                    //                         }
                    //                     })
                    //                 })
                    //                 break
                    //             }
                    //         }
                    //     }

                    //     for(var i = 0; i < this.invoiceAdjustments.length; i++) {

                    //         let adj = this.invoiceAdjustments[i]

                    //         this.sanitize(adj)

                    //     }

                    //     this.$bvModal.hide("m-add-adjustment")
                    // })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        changeAdjustment() {
            this.isChangeAdjustment = true
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.activeItem.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        // addRow() {
        //     this.invoiceAdjustments.push({ name: "", adjustmentSelect: "", adjustment: "", adjustmentPercentage: "" })
        // },

        confirmAdd(id) {

            let confirmable = true

            for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                let adj = this.invoiceAdjustments[i]

                if (this.$helper.isBlank(adj.adjustmentSelect) || (this.$helper.isBlank(adj.adjustment) && this.$helper.isBlank(adj.adjustmentPercentage)) || this.$helper.isBlank(adj.adjustmentSelect.id)) {
                    confirmable = false
                    return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                }

            }

            if (confirmable) {
                let payload = new FormData()
                let jsonData = {
                    adjInvoice: this.invoiceAdjustments.map(it => {
                        if (this.$helper.isBlank(it.adjustmentPercentage)) {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: this.$helper.toNumber(it.adjustment),
                                adjustmentPercentage: null,
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                        else {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: parseInt(this.activeItem.final_price * parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100),
                                adjustmentPercentage: Number(parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2),
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                    })
                }

                payload.append("data", JSON.stringify(jsonData))
                payload.append("id", id)
                payload.append("changed", this.isChangeAdjustment)

                this.isSubmitting = true
                this.$axios.post("inventory/update-invoice-adjustments", payload).then(res => {
                    this.$helper.toastSuccess(this, "Update Adjustment Berhasil!")
                    this.$bvModal.hide("m-item-to-adjust")
                    this.getItems(this.currentPage)
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            }

        },


        sanitizeString(str) {
            let cleaned = String(str).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            return res
        },

        specName(id) {
            switch (id) {
                case 1: return "ORI"
                case 2: return "RESMI"
                case 3: return "RR"
                case 5: return "LN"
                default: return "-"
            }
        },
    },

    computed: {
        isGradeOnly() {
            return this.item.pending_type == 1
        }
    },

    created() {
        this.init()
    }
}
</script>

<style scoped>
.multiselect__option--highlight .option__small {
    color: #d8dbde !important;
}

.multiselect__option--selected .option__small {
    color: #ccccee !important;
}

.multiselect__option--highlight.multiselect__option--selected .option__small {
    color: #ccccee !important;
}

/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
